<template>
  <div class="gov-course-detail">
    <!-- 顶部背景 -->
    <div class="top-banner-box">
      <div class="top-banner-img" :style="{ backgroundImage: `url(${headerBgUrl})` }">
      </div>
    </div>
    <!-- 公司简介 -->
    <div class="bannerInfo">
      <div class="info-con">
        <div class="info-pic" :style="{ backgroundImage: `url(${reseult.avatar})` }">
        </div>
        <div class="info-title">{{ reseult.title }}</div>
        <!-- <div class="info-des">{{ reseult.description }}</div> -->
        <div class="info-service">服务能力：
          <span v-for="(item, index) in reseult.capabilityList" :key="index">
            <span class="info-text">{{ item.title + ' ' }}</span>
          </span>
        </div>
        <div style="margin-top: 20px;">
            {{ reseult.serviceAre }}
        </div>
        <div class="info-link">联系方式：
          <span>{{ reseult.linkMethod }}</span>
        </div>
      </div>
    </div>
    <div class="container">
      <div v-html="reseult.content" class="full-element"></div>
    </div>
    <div class="footer">
      <div class="footer-title">转型案例</div>
      <div class="footer-cas">
        <div class="cas">
          <el-carousel :interval="5000" arrow="always" trigger="click">
            <el-carousel-item v-for="(item, index) in   caseList " :key="index">
              <div class="casItem">
                <div class="caseItem-pic" :style="{ backgroundImage: `url(${item.pic})` }"></div>
                <div class="caseItem-con">
                  <div class="caseItem-title">{{ item.title }}
                    <div class="caseItem-summary">{{ item.description }}</div>
                  </div>
                  <div class="caseItem-btn" @click="goCaseDetail(item.uuid)">查看详情</div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getProviderDetail, getDictionaryItem } from "../../utils/interface"
export default {
  metaInfo() {
    return {
      title: this.metaTitle,
      meta: [
        {
          // set meta
          name: "keywords",
          content: '数字化|服务商|服务能力|转型案例|解决方案',
        },
        {
          // set meta
          name: "description",
          content: this.metaDescription,
        },
      ],
    }
  },
  data() {
    return {
      headerBgUrl: "",
      params: {
        currentPage: 1,
        pageSize: 4,
        courseStatus: "0",
        sellType: "COURSE",
        total: 5,
      },

      reseult: {},

      dataLoading: false,

      content: "",

      curUuid: "",
      caseList: [
        {
          pic: require('../../assets/publicService/resourcePool/2.png'),
          title: '企业初创解决方案1',
          description: '企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案',
        },
        {
          pic: require('../../assets/publicService/resourcePool/2.png'),
          title: '企业初创解决方案2',
          description: '企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案',
        },
        {
          pic: require('../../assets/publicService/resourcePool/2.png'),
          title: '企业初创解决方案3',
          description: '企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案企业初创解决方案',
        }
      ], // 案例
      metaTitle: "",
      metaDescription: "",
    }
  },
  created() {
    this.getParams()
    this.getOptionsData()
  },
  methods: {
    getParams() {
      this.curUuid = this.$route.query.uuid
      this.getDetailByUuid()
    },
    getDetailByUuid() {
      let that = this
      let api = getProviderDetail
      api(this.curUuid).then((res) => {
        if (res.data) {
          this.reseult = res.data
          this.metaTitle = res.data.title + "-公共服务平台"
          this.metaDescription =  res.data.description.length>70?res.data.description.substring(0,70):res.data.description;
          this.caseList = res.data.caseList
        }
      })
    },
    getOptionsData() {
      //顶部背景图
      getDictionaryItem({
        code: "FWS_BANNER",
      }).then((res) => {
        if (res != null && res.length > 0) {
          this.headerBgUrl = res[0].value
        } else {
          this.headerBgUrl = ""
        }
      })
    },
    toViewVideo() { },
    onClickType(item) {
      this.params.courseStatus = item.value
      this.getDataList()
    },
    onChangeCurrent(e) {
      this.params.current = e
      this.getDataList()
    },
    // 点击进入案例详情页
    goCaseDetail(caseId) {
      let routeData = this.$router.resolve({
        path: "/caseDetail",
        query: {
          uuid: caseId
        }
      })
      window.open(routeData.href, "_blank")
    },
    onClickDetail() { },
    onClickLookMore() { },
  },
}
</script>
<style scoped lang="less">
@basic-colors: #009999;

/deep/ .video-js .vjs-big-play-button {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.gov-course-detail {
  // background: rgb(245 245 245);
  // background: #ffffff;
  position: relative;
  top: -80px;
  margin-bottom: -80px;

  .top-banner-box {
    // background-color: #f7f8fb;

    .top-banner-img {
      height: 400px;
      width: 100%;
      overflow: hidden;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .bannerInfo {
    width: 1300px;
    margin: 0 auto;
    color: #fff;
    display: flex;
    flex-flow: row nowrap;
    justify-content: start;
    font-weight: normal;
    position: relative;
    background-color: #fff;
    color: #000;
    border-radius: 16px;
    box-shadow: 0 2px 8px 0 rgba(20, 30, 49, .1);
    top: -120px;
    padding: 28px 40px 40px;
    box-sizing: border-box;

    .info-pic {
      width: 120px;
      height: 70px;
      background: no-repeat center center/100% 100%;
      border-radius: 16px;
    }

    .info-con {
      margin-left: 40px;
      flex: 1;

      .info-title {
        font-size: 28px;
        font-weight: bold;
        margin-bottom: 40px;
      }

      .info-des {
        margin-top: 20px;
        font-size: 16px;
      }

      .info-service {
        margin-top: 20px;

        .info-text {
          margin: 0 5px;
          padding: 4px 10px;
          background-color: #2d50a130;
          color: #2d50a1;
          border-radius: 6px;
        }
      }

      .info-link {
        margin-top: 20px;
      }
    }
  }

  .container {
    width: 1300px;
    margin: 10px auto;
    position: relative;
    top: -105px;

    .full-element {
      width: 100%;
      margin: 0 0 20px;
      box-sizing: border-box;
      padding: 20px 40px;
      // box-shadow: 0 0 8px #99999947;
      border-radius: 16px;
    }
  }

  .footer {
    width: 100%;
    min-height: 300px;
    background-color: #f3f5fb;
    overflow: hidden;
    position: relative;
    top: -105px;
    margin-bottom: -185px;

    .footer-title {
      font-size: 28px;
      font-weight: 600;
      color: #000;
      margin: 20px 0;
      text-align: center;
      position: relative;
    }

    .footer-cas {

      .cas {
        width: 1408px;
        height: 380px;
        margin: 0 auto;

        .casItem {
          width: 1300px;
          height: 380px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          .caseItem-pic {
            width: 580px;
            height: 325px;
            background: no-repeat center center/100% 100%;
            border-radius: 12px;
          }

          .caseItem-con {
            flex: 1;
            height: 325px;
            margin-left: 30px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .caseItem-title {
              color: #2d50a1;
              font-size: 24px;
              font-weight: 600;

              .caseItem-summary {
                color: #445566;
                font-size: 16px;
                line-height: 1.75;
                margin-top: 40px;
                font-weight: normal;
              }
            }

            .caseItem-btn {
              width: 100px;
              height: 30px;
              line-height: 30px;
              background-color: #2d50a1;
              border-radius: 15px;
              color: #fff;
              font-size: 14px;
              text-align: center;
              cursor: pointer;
              // align-self: end;
              margin-bottom: 20px;
            }
          }
        }
      }

      /deep/ .el-carousel__container {
        height: 380px;
      }

      /deep/ .el-carousel__item {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      /deep/ .el-carousel__arrow--left{
        left: 0;
      }
      /deep/ .el-carousel__arrow--right{
        right: 0;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/resourcePool/providerDetail.vue